import { GuideName } from '@app/api/guides';
import {
  GridLookup,
  GridOption,
} from '@app/components/common/editable-grid/model';

export const outletGuideSources: Record<string, GuideName> = {
  segment: 'outlet_segment',
  division: 'division',
  room_type: 'outlet_room_type',
  status: 'outlet_status',
  payment_type: 'payment_type',
  price_list: 'price_list',
  sub_channel: 'outlet_sub_channel',
};

export function channelOptions(subChannels: EntityBase[]): EntityBase[] {
  const groups = new Map<string, number[]>();
  for (const item of subChannels) {
    const name = (item as EntityBase & { channel?: string }).channel;
    if (!name) {
      continue;
    }
    groups.set(name, [...(groups.get(name) || []), Number(item.id)]);
  }
  return Array.from(groups, ([name, ids]) => ({
    id: `group:${ids.sort((a, b) => a - b).join('|')}`,
    name,
  }));
}

export function searchOutletLookup(
  client: {
    get: (payload: any) => Promise<any>;
    getPaginated: (payload: any) => Promise<any>;
  },
  name: 'distributor' | 'route_number'
): GridLookup {
  return {
    search: async (search, offset) => {
      if (!search) {
        return { options: [], hasMore: false };
      }
      const response =
        name === 'route_number'
          ? await client.getPaginated({
              name,
              search,
              limit: '30',
              offset: String(offset),
            })
          : await client.get({ name, search, is_active: 'false' });
      if (response?.code !== 200) {
        throw new Error('Не удалось загрузить справочник');
      }
      // Swagger wraps the paginated route result in an array; the existing API also returns an object.
      const page =
        Array.isArray(response.data) && response.data[0]?.data
          ? response.data[0]
          : response.data;
      const items = name === 'route_number' ? page?.data : response.data;
      if (!Array.isArray(items)) {
        throw new Error('Некорректный ответ справочника');
      }
      const options: GridOption[] = items.map((item) => ({
        value: String(item.id),
        label: item.name,
      }));
      return {
        options,
        hasMore: name === 'route_number' && offset + items.length < page.total,
      };
    },
  };
}
